import { render, staticRenderFns } from "./ModuleInactive.vue?vue&type=template&id=d99d16f0&scoped=true"
import script from "./ModuleInactive.vue?vue&type=script&lang=js"
export * from "./ModuleInactive.vue?vue&type=script&lang=js"
import style0 from "./ModuleInactive.vue?vue&type=style&index=0&id=d99d16f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d16f0",
  null
  
)

export default component.exports